import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Feed } from 'src/app/models/Feed';
import { AuthService } from 'src/app/services/auth.service';
import { FeedService } from 'src/app/services/modelService/feed.service';
import { ReactionService } from 'src/app/services/modelService/reaction.service';

@Component({
  selector: 'app-bhawan',
  templateUrl: './bhawan.component.html',
  styleUrls: ['./bhawan.component.scss'],
})
export class BhawanComponent implements OnInit {
  imageHeight = "80vw";
  @Input() details = false;

  showAllReactions = false;
  hoverTimeout: any;
  @Input() feed: Feed = new Feed();

  showEmojiBox = false;
  constructor(public reactionService: ReactionService, public feedService: FeedService,
    public auth: AuthService, private router: Router, private platform: Platform) { }

  ngOnInit() {
    this.auth.getLoggedInEmployee();
    this.feedService.feed = this.feed;
    if(this.platform.width()>this.platform.height()){
      this.imageHeight = "28vw";
    }
  }

  clickEmoji(emoji) {
    this.showEmojiBox = false;
    this.reactionService.reaction.reaction = emoji;
    console.log(this.reactionService.reaction);
    this.feedService.sendMessage(this.feed);
  }

  viewFeedDetails() {
    this.router.navigate(['/post-details', this.feed.id]);
  }

  getImage() {
    if (this.feed.image_urls && this.feed.image_urls.length > 0) {
      return this.feed.image_urls[0];
    } else {
      return './assets/imgs/bhawan.png';
    }
  }
  openMap(url: string) {
    const isShortLink = url.includes('maps.app.goo.gl');

    if (isShortLink) {
      // Allow browser to resolve the short link via JS, not <a>
      window.open(url, '_blank');
    } else {
      window.open(url, '_blank');
    }
  }
}
